export const FARTHER_MODELS_TYPE_NAME = "Farther Asset Management";
export const FAM = "FAM";
